import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GLinkConfigService } from 'app/core/services/config.service';
import { glinkAnimations } from 'app/core/animations';
import { AuthenticationService } from 'app/core/services/authentication.service';

import * as toastr from 'toastr';
import { RestorePassword } from 'app/core/models/restore-password.type';

@Component({
    selector   : 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls  : ['./forgot-password.component.scss'],
    animations : glinkAnimations
})
export class ForgotPasswordComponent implements OnInit, OnDestroy
{
    forgotPasswordForm: FormGroup;
    forgotPasswordFormErrors: any;
    isWaiting = false;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {GLinkConfigService} _glinkConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _glinkConfigService: GLinkConfigService,
        private _formBuilder: FormBuilder,
        private authService: AuthenticationService
    )
    {
        // Configure the layout
        this._glinkConfigService.config = {
            layout: {
                navbar : {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer : {
                    hidden: true
                }
            }
        };

        // Set the defaults
        this.forgotPasswordFormErrors = {
            email: {}
        };

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.forgotPasswordForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });

        this.forgotPasswordForm.valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.onForgotPasswordFormValuesChanged();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On form values changed
     */
    onForgotPasswordFormValuesChanged(): void
    {
        for ( const field in this.forgotPasswordFormErrors )
        {
            if ( !this.forgotPasswordFormErrors.hasOwnProperty(field) )
            {
                continue;
            }

            // Clear previous errors
            this.forgotPasswordFormErrors[field] = {};

            // Get the control
            const control = this.forgotPasswordForm.get(field);

            if ( control && control.dirty && !control.valid )
            {
                this.forgotPasswordFormErrors[field] = control.errors;
            }
        }
    }


    performReset() {
        if (this.forgotPasswordForm.invalid) {
            return;
        }

        this.isWaiting = true;

        const resetPasswordInfo = new RestorePassword();
        resetPasswordInfo.setEmailValue(this.forgotPasswordForm.get('email').value);

        this.authService.resetPassword(resetPasswordInfo).subscribe(res => {
        
            if (res.status === 'OK') {
                toastr.success(res.message);
            }
       
        this.isWaiting = false;

        });

        
    }
}
